// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { FormatElevation, FormatElevationHeader } from './Formatters'

export const columns = [
  {
    columnKey: 'siteName',
    columnHeader: 'Site Name',
    sortable: true,
  }, {
    columnKey: 'latitude',
    columnHeader: 'Latitude',
    columnWidth: '140px',
    sortable: true,
  }, {
    columnKey: 'longitude',
    columnHeader: 'Longitude',
    columnWidth: '140px',
    sortable: true,
  }, {
    cellFormatter: FormatElevation,
    columnKey: 'elevation',
    columnHeader: 'Elevation',
    columnWidth: '120px',
    headerFormatter: FormatElevationHeader,
    sortable: true,
  }, {
    columnKey: 'callSign',
    columnHeader: 'Call Sign',
    columnWidth: '100px',
    sortable: true,
  }, {
    columnKey: 'asr',
    columnHeader: 'ASR',
    columnWidth: '100px',
    sortable: true,
  }, {
    columnKey: 'contactCode',
    columnHeader: 'Contact Code',
    columnWidth: '100px',
    sortable: true,
  }, {
    columnKey: 'distance',
    columnHeader: 'Distance',
    columnWidth: '56px',
    sortable: true,
  },
]
